import { FC } from 'react'
import { useColorModeValue } from '@chakra-ui/react'
import LogoWrapper, { LogoIconWrapper } from './logo-styles'

import logoMono from '../../images/logo_bemap.png'
import logoMonoWhite from '../../images/logo_bemap.png'
import logoIcon from '../../images/icon-bemap.png'

export const Logo: FC<{ url?: string }> = ({ url }) => {
  const logoImg = url ? url : useColorModeValue(logoMono, logoMonoWhite);

  return (
    <LogoWrapper src={logoImg} />
  )
}

export const LogoIcon: FC = () => {
  return (
    <LogoIconWrapper src={logoIcon} />
  )
}